export default __webpack_public_path__ + "static/media/close-detail.f6d87e78.svg";